import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutSidebar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutSidebar"><Path d="M3 21V3H9V21L3 21Z" fill="currentColor"/><Path d="M10.5 21L21 21V12.75H10.5V21Z" fill="currentColor"/><Path d="M21 11.25V3H10.5V11.25H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutSidebar;
